<template>
  <print v-if="isPrint" :board="board" :form="form" :header="header" />
  <div v-else>
    <div class="mb-5">
      {{ $t("※ 각 부서 관리감독자가 최초 작성 후 보건관리자(확인자)에게 알림을 전송합니다.") }}<br />
      &nbsp; &nbsp; &nbsp;
      {{ $t("보건관리자가") }} <span style="color: #7e72f2">{{ $t("구성성분 및 함유량 등") }}</span
      >{{ $t("기입/저장 후, 관리감독자가 관리상태를 기입/저장하여 보건관리자에게 알림을 전송합니다.") }}
    </div>

    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: $t('알림 대상자 선택') }]" />

    <!-- MSDS -->
    <msds-module :readonly="board.readonly" v-model="form.msds" :is-print="isPrint" />

    <!-- 결재란 -->
    <div class="mt-8 grid">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>


    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="내용을 입력해주세요"
    />
    <file-upload-module class="mt-8" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import MsdsModule from "@/views/boards/single-page/447/MsdsModule.vue";
import moment from "moment";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "./Print.vue";
import TableScore from "@/components/TableScore.vue";

export default {
  components: {
    TableScore,
    Print,
    NameWithSignatureRow,
    MsdsModule,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerYear = `${value.year}`;
        this.form.headerMonth = value.month >= 10 ? value.month : "0" + value.month;
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.headerYear": {
      immediate: true,
      deep: true,
      handler(value) {
        const month = typeof this.form.headerMonth === "string" ? parseInt(this.form.headerMonth) : this.form.headerMonth;
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`;
        this.form.headerDateString = `${this.form.headerYear}년 ${month >= 10 ? month : "0" + month}월`;
      },
    },
    "form.headerMonth": {
      immediate: true,
      deep: true,
      handler(value) {
        const month = typeof this.form.headerMonth === "string" ? parseInt(this.form.headerMonth) : this.form.headerMonth;
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`;
        this.form.headerDateString = `${this.form.headerYear}년 ${month >= 10 ? month : "0" + month}월`;
      },
    },
    "form.msds": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.msdsProcesss = [];
        this.form.msdsMaterials = [];
        for (const msds of value) {
          if (msds.작업공정) {
            this.form.msdsProcesss.push(msds.작업공정);
          }
          if (msds.물질명) {
            this.form.msdsMaterials.push(msds.물질명);
          }
        }
      },
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        msds: [],

        photoList: [],
        fileList: [],

        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: "",
        headerDateString: "",

        msdsProcesss: [],
        msdsMaterials: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, "0");
    },
    translationMap() {
      const prefix = "보건점검 현황.MSDS 리스트 관리";
      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.MSDS 리스트 관리.MSDS`]: this.form.msds.map((item) => {
          return {
            소속: item.소속,
            "작업공정(담당명)": item.작업공정,
            "물질명(제품명)": item.물질명,
            "월 사용량": item.월사용량,
            "구성성분 및 함유량.CAS번호": item.CAS번호,
            "구성성분 및 함유량.구성성분": item.구성성분,
            "구성성분 및 함유량.함유량(%)": item.함유량,
            측정대상: item.측정대상,
            "측정주기(개월)": item.측정주기,
            특검대상: item.특검대상,
            "특검주기(개월)": item.특검주기,
            특별관리물질: item.특별관리물질,
            비고: item.비고,
          };
        }),

        [`${prefix}.MSDS 리스트 관리.결재.작성자`]: this.form.sign1.name,
        [`${prefix}.MSDS 리스트 관리.결재.검토자`]: this.form.sign2.name,
        [`${prefix}.MSDS 리스트 관리.결재.회람자`]: this.form.sign3.name,
        [`${prefix}.MSDS 리스트 관리.결재.승인자`]: this.form.sign4.name,
      };

      return translateData;
    },
    translate(translate) {
      const prefix = "보건점검 현황.MSDS 리스트 관리";
      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.form.stdInfo.공정명 = translate[`${prefix}.기본정보.공정명`];

      const msds = translate[`${prefix}.MSDS 리스트 관리.MSDS`];
      const _msds = JSON.parse(JSON.stringify(this.form.msds));
      for (let i = 0; i < msds.length; i++) {
        _msds[i].소속 = msds[i]["소속"];
        _msds[i].작업공정 = msds[i]["작업공정(담당명)"];
        _msds[i].물질명 = msds[i]["물질명(제품명)"];
        _msds[i].월사용량 = msds[i]["월 사용량"];
        _msds[i].CAS번호 = msds[i]["구성성분 및 함유량.CAS번호"];
        _msds[i].구성성분 = msds[i]["구성성분 및 함유량.구성성분"];
        _msds[i].함유량 = msds[i]["구성성분 및 함유량.함유량(%)"];
        _msds[i].측정대상 = msds[i]["측정대상"];
        _msds[i].측정주기 = msds[i]["측정주기(개월)"];
        _msds[i].특검대상 = msds[i]["특검대상"];
        _msds[i].특검주기 = msds[i]["특검주기(개월)"];
        _msds[i].특별관리물질 = msds[i]["특별관리물질"];
        _msds[i].비고 = msds[i]["비고"];
      }
      this.$set(this.form, "msds", _msds);

      this.form.sign1.name = translate[`${prefix}.MSDS 리스트 관리.결재.작성자`];
      this.form.sign2.name = translate[`${prefix}.MSDS 리스트 관리.결재.검토자`];
      this.form.sign3.name = translate[`${prefix}.MSDS 리스트 관리.결재.회람자`];
      this.form.sign4.name = translate[`${prefix}.MSDS 리스트 관리.결재.승인자`];
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
